export default "__VITE_ASSET__Cgu_ukuE__"